<template>
  <div
    class="statistics-takt"
    :style="`
      ${!width && no_zoom?'width: calc(var(--workpackage_width) + 8px)':''}
      ${width?`width: ${width}`:''}
      `"
    >
    <div class="statisitic-hover">
      {{ value }}
    </div>
    <slot/>
  </div>
</template>
<script>
  export default {
    props: ['no_zoom', 'width', 'value'],
    data: () => ({
    }),
  }
</script>
<style>
  .statistics-takt {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
  }

  .statisitic-hover {
    display: none;
    text-align: center;
  }

  .statistics-takt:hover .statisitic-hover{
    display: flex;
  }
</style>
